/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-file-service.ts
 *
 * Created by kyang on 2/10/21.
 */

//
// This service contains all the logic used to
// upload files for package media tab.
//

angular.module('prism-ui.package').service('PackageFileUploadService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    AsperaConnectService: JS5Object,
    TempFileUploadService: JS5Object,
    UtilsService: JS5Object,
) {

    //===============//
    // Aspera Upload //
    //===============//

    this.parseAsperaValidationResult = (packageObject: JS5Object, asperaFileObject: JS5Object, result: JS5Object) => {
        let virtualRoot = AsperaConnectService.asperaConnectProperties.virtualRoot;
        let destinationRoot = AsperaConnectService.asperaConnectProperties.destinationRoot;
        let packageId = packageObject.id;
        let fileName = UtilsService.getFileNameFromLocalPath(asperaFileObject.name);
        let resultPath = `${virtualRoot}${destinationRoot}${packageId}/${fileName}`;
        if (result.uploadedData) {
            result.uploadedData.asperaPath = resultPath;
        } else {
            result.uploadedData = resultPath;
        }
        return result;
    };


    //===================//
    // Local File Upload //
    //===================//

    let localConfigsReadyForUpload: JS5Object[] = [];

    this.registerLocalConfigForUpload = (uploaderConfig: JS5Object) => {
        if (localConfigsReadyForUpload.indexOf(uploaderConfig) === -1) {
            localConfigsReadyForUpload.push(uploaderConfig);
        }
    };

    this.unregisterLocalConfig = (uploaderConfig: JS5Object) => {
        _.pull(localConfigsReadyForUpload, uploaderConfig);
    };


    //========================//
    // Shared Implementations //
    //========================//

    this.unregisterAllFiles = () => {
        AsperaConnectService.unregisterAllFiles();
        localConfigsReadyForUpload = [];
    };

    this.uploadFiles = (packageObject: JS5Object, loadingIndicator: JS5Object) => {
        if (AsperaConnectService.initialized) {
            AsperaConnectService.beginUpload(`${packageObject.id}/`);
        }
        let subdirectory = `${packageObject.id}/`;
        let virtualPathPromises: JS5Object[] = [];
        _.forEach(localConfigsReadyForUpload, (uploaderConfig: JS5Object) => {
            loadingIndicator.show = false;
            let uploads = TempFileUploadService.uploadFiles(uploaderConfig, subdirectory, packageObject.id);
            for (const upload of uploads) {
                upload.uploadPromise.then(() => {
                    uploaderConfig.removeFromQueue(upload.fileItem);
                    this.unregisterLocalConfig(uploaderConfig);
                });
                // Callback ensures that listener completes before promise is resolved
                virtualPathPromises.push(upload.virtualPathPromise.then((virtualPath: string) => {
                    return upload.fileItem.onVirtualPathSet(virtualPath);
                }));
            }
        });
        return $q.all(virtualPathPromises);
    };
});
